<template>
  <div>
    <ContentHeader title="Order List" />
    <b-modal content-class="your-class" id="bv-modal-example" centered hide-footer hide-header>
      <div class="text-center">
        <b-spinner variant="danger" label="Text Centered"></b-spinner>
      </div>
    </b-modal>
    <table-skeleton v-if="loading"></table-skeleton>
    <section v-else class="content">
      <div class="container-fluid">
        <div class="card filter active">
          <div class="row p-3">
            <div class="col">
              <label for="robotName">Robot Name</label>
              <select
                id="robotName"
                class="form-select"
                v-model="filter.robotName"
              >
                <option value="ALL">ALL</option>
                <option
                  v-for="item in robots"
                  :key="item.index"
                  :value="item.name"
                >
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="card-tools">
                  <div class="d-flex filter-container">
                    <select
                      class="form-select mr-3 w-25 select-perpage"
                      v-model="table.perPage"
                    >
                      <option value="5">5</option>
                      <option value="10" selected>10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                    <input
                      type="text"
                      name="search"
                      class="form-control w-75 search-bar"
                      placeholder="Search"
                      v-model="table.filter"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <b-table
                  hover
                  responsive
                  :items="subscriptionData"
                  :fields="table.fields"
                  :current-page="table.currentPage"
                  :per-page="table.perPage"
                  :filter="table.filter"
                  :filter-included-fields="['product_name', 'investor_name']"
                  @filtered="onFiltered"
                  show-empty
                >
                  <template #empty="scope">
                    <p class="text-center">
                      {{ scope.emptyText }}
                    </p>
                  </template>
                  <template #emptyFiltered="scope">
                    <p class="text-center">
                      {{ scope.emptyFilteredText }}
                    </p>
                  </template>
                  <template #cell(No)="data">
                    {{
                      (table.currentPage - 1) * table.perPage + data.index + 1
                    }}
                  </template>
                  
                  <template #cell(created_at)="data">
                    {{ formatDate(data.item.created_at) }}
                  </template>
                  <template #cell(deposit_amount)="data">
                    $ {{ data.item.deposit_amount }}
                  </template>
                  <template #cell(id)="data">
                    <a
                      href="#"
                      @click="showDetail('view-detail-modal', data.item.id)"
                    >
                      <i class="fas fa-key text-info"></i>
                    </a>
                  </template>
                </b-table>
              </div>
              <b-pagination
                v-model="table.currentPage"
                :total-rows="table.totalRows"
                :per-page="table.perPage"
                class="my-0 p-3"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    <b-modal
      id="view-detail-modal"
      ref="view-detail-modal"
      size="lg"
      title="Activation Code Submition"
      centered
      hide-footer
    >
      <div class="p-1 p-md-4">
        <form @submit.prevent="submitactive()">
          <h2>Activation Code</h2>
            <div class="input-active-code p-1 w-100" >
              <input class="p-3" v-model="activation_code" type="text" name="activation_code" placeholder="XXXX-XXXX-XXXX">
              <div @click="generateCode" class="btn btn-outline-success ml-md-3">Generate</div>
            </div>
            <div class="text-danger" v-if="$v.activation_code.$error">
              <small>Activation Code is Required</small>
            </div>
            <h3 class="grey mt-4">Order Details</h3>
            <div class="row data-activate">
                <div class="col-md-6">
                    <p class="grey">Investor</p>
                    <h4>{{ sub_detail[0].investor.name }}</h4>
                </div>
                <div class="col-md-6">
                    <p class="grey">Deposit Amount</p>
                    <h4>$ {{ sub_detail[0].deposit_amount }}</h4>
                </div>
                <div class="col-md-6">
                    <p class="grey">Robot</p>
                    <h4>{{ sub_detail[0].product_name }}</h4>
                </div>
                <div class="col-md-6">
                    <p class="grey">Subscription At</p>
                    <h4>{{ formatDate(sub_detail[0].created_at) }}</h4>
                </div>
                <div class="col-md-6">
                    <p class="grey">Investor note</p>
                    <h4>{{ sub_detail[0].investor_note }}</h4>
                </div>
            </div>
            <div class="mt-4 mb-4">
                <button id="btn-submit-generate" type="submit" class="btn btn-success float-right mb-3">Save Activation Code</button>
            </div>
          </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TableSkeleton from "@/components/loading-screen/TableSkeleton.vue";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import swal from 'sweetalert'
import apiVendor from "../services/VendorApiServices";
import apiClient from "../services/ApiServices";

export default {
  components: {
    ContentHeader,
    TableSkeleton,
  },
  data() {

    return {
      submitStatus: null,
      loading: true,
      robots: [],
      order: [],
      activation_code:'',
      sub_detail: [
        {
          order_id: null,
          deposit: null,
          product_name: null,
          deposit_amount: null,
          date: null,
          investor: {
            name: null,
          },
        },
      ],
      form: {
        order_id: null,
        investor: null,
        product_name: null,
        deposit_amount: null,
        date: null,
      },
      filter: {
        robotName: "ALL",
      },
      table: {
        currentPage: 1,
        totalRows: 1,
        perPage: 10,
        filter: "",
        fields: [
          "No",
          {
            key: "investor_name",
            sortable: true,
          },
          {
            label: "Robot Name",
            key: "product_name",
            sortable: false,
          },
          {
            label: "Subscribed At",
            key: "created_at",
            sortable: true,
          },
          {
            label: "Deposit Amount",
            key: "deposit_amount",
            sortable: false,
          },
          {
            label: "Action",
            key: "id",
          },
        ],
      },
    };
  },
  validations: {
      activation_code: {
        required,
    },
  },
  async mounted() {
    try {
      const orderResponse = await apiVendor.get(`${this.$user_id}/order/`)
      if(orderResponse) {
        this.order = orderResponse.data?.data
      }
      

      const robotResponse = await apiClient.get(`?vendor_id=${this.$user_id}&without_broker=true`)
      if(robotResponse) {
        this.robot = robotResponse.data?.data
      }

      this.table.totalRows = this.order.length;
    } catch (error) {
      this.$swal(
        "Oooopss....",
        error.response.data.data.massage,
        "error"
      );
    } finally {
      this.loading = false;
    }
  },
  computed: {
    subscriptionData() {
      if (this.filter.robotName === "ALL") {
        return this.order;
      } else if (
        this.filter.robotName != "ALL"
      ) {
        return this.order.filter(
          (item) => item.product_name == this.filter.robotName
        );
      } 

      return this.order.filter(
        (item) =>
          item.product_name == this.filter.robotName
      );
    },
  },
  methods: {
  async generateCode(){
      try {
      let order = await apiVendor.get(
        `activation_code/`
      );
      
      this.activation_code = order.data.data;
    } catch (error) {
      console.log(error);
    }
    },
    submitactive(){
      document.getElementById("btn-submit-generate").disabled = true
      this.$v.$touch();
      if (!this.$v.$invalid) {
      this.$bvModal.show('bv-modal-example')
      let data = new FormData();
      data.append("activation_code", this.activation_code)
      apiVendor.put(`transaction/${this.sub_detail[0].id}/`, data)
      .then((response) => {
            if(response.data.status == 200) {
                document.getElementById("btn-submit-generate").disabled = false
                this.$bvModal.hide('view-detail-modal')
                this.$bvModal.hide('bv-modal-example')
                apiVendor.get(`${this.$user_id}/order/`).then(response =>{
                this.order=response.data.data
                this.table.totalRows = this.order.length;
                }).catch(() => {
                })
                apiClient.get(`?vendor_id=${this.$user_id}&without_broker=true`).then(response =>{
                this.robots=response.data.data
                }).catch(() => {
                })
                swal('Congratulation!!!', 'Activation code updated.', 'success', {
                          button: "OK"
                      })
                
            } else {
                document.getElementById("btn-submit-generate").disabled = false
                this.$bvModal.hide('bv-modal-example')
                // validation.value = response.data.response
            }
        }).catch(() => {
            document.getElementById("btn-submit-generate").disabled = false
            this.$bvModal.hide('bv-modal-example')
        })
      }else{
        document.getElementById("btn-submit-generate").disabled = false
        this.$bvModal.hide('bv-modal-example')
      }

    },
    formatDate(value) {
      return moment(value).format("DD MMMM YYYY hh:mm");
    },
    onFiltered(items) {
      this.table.totalRows = items.length;
      this.table.currentPage = 1;
    },
    
    showDetail(modal, id) {
      this.$refs[modal].show();
      this.activation_code = null
      this.$v.$reset()
      this.sub_detail = this.order.filter((item) => item.id === id);
    },
  },
};
</script>

<style scoped>
 #bv-modal-example> .modal-dialog> .modal-content{
  background: none !important;
  box-shadow: none !important;
  border: 0px !important;
}
#bv-modal-example> .modal-dialog> .modal-content{
  background: none !important;
  box-shadow: none !important;
  border: 0px !important;
}
@media (max-width: 767px) {
  .filter .col-md-3 .form-select {
    margin-bottom: 1rem !important;
  }
}
.filter {
  transition: max-height 0.75s ease-in-out;
  max-height: 0;
}
.filter.active {
  max-height: 500px;
}
.filter .form-select {
  transition: max-height 0.75s ease-in-out;
  max-height: 0;
}
.filter.active .form-select {
  max-height: 300px;
}
.input-active-code{
    border: 1px solid grey;
    border-radius: 10px;
    justify-content: space-between;
}
.input-active-code input{
    width: 70%;
    padding: 0.4rem 1rem;
    border: 0px !important;
}
.grey{
    color:grey;
}
.data-activate p{
    margin-bottom: 0px !important;
}
@media (min-width: 1023px) {
    .input-active-code{
        width: 50%;
    }
    .input-active-code input{
    width: 80%;
}
}
</style>